<template>
    <section class="page">
        <!-- 顶部标题栏 -->
        <div class="header">View Promoted Products</div>

        <!-- 提示文字 -->
        <div class="tips">
            <p class="tips-text">The following are third-party products.</p>
            <p class="tips-text">Please read the terms carefully and choose wisely.</p>
        </div>

        <!-- 产品列表 -->
        <div class="product-list">
            <div
                class="product-card"
                :class="{'product-card-disabled': !item.online}"
                v-for="(item, index) in productList"
                :key="item.dcId"
            >
                <!-- 左侧Logo + 产品名 -->
                <div class="product-left">
                    <img class="product-logo" :src="baseUrl + '/' +item.dcLogoUrl" />
                    <span class="product-name">{{ item.dcName}}</span>
                </div>

                <!-- 中间：域名 + 提示 -->
                <div class="product-right">
					<div class="product-info" :class="item.dcType == 2 ? 'info-app' : ''">
						<div class="product-domain" v-if="item.dcType == 1 || (item.dcType == 3 && isIOSDevice)">{{ item.h5Url }}</div>
						
						<!-- 跳应用市场 -->
						<template v-if="item.dcType == 2">
							<div class="action-btn" @click="handleAction(item)" v-if="isIOSDevice">
							    <img src="./img/app_store.svg"  class="play-icon"/>
								<span>Appstore</span>
							</div>
							<div class="action-btn" @click="handleAction(item)" v-else >
							    <img src="./img/google_play.png"  class="play-icon"/>
								<span>GooglePlay</span>
							</div>	
						</template>
					    
						<!-- 下载apk -->
						<template v-else-if="item.dcType == 3">
							<div class="action-btn" @click="handleAction(item)" v-if="isIOSDevice">Copy</div>
							<div class="action-btn" @click="handleAction(item)" v-else >Download</div>
						</template>
						
						<div class="action-btn" @click="handleAction(item)" v-else>Copy</div>
					</div>
					
                    <div class="product-desc" :class="item.dcType == 2 ? 'desc-app' : ''">
						<span v-if='item.dcType == 2'>Tap Download to open Play Store and install the app.</span>
						<span v-else-if='item.dcType == 3 && !isIOSDevice'>Tap Download the apk install the app.</span>
						<span v-else>Please click the link and open it in your browser.</span>
                    </div>
                </div>
               
                <!-- 未上线遮罩 -->
                <div v-if="!item.online" class="disabled-mask">
                    <span class="disabled-text">Malapit nang ilunsad</span>
                </div>
            </div>
			
			
			<div
			    class="product-card product-card-disabled"
			    v-for="(item, index) in virtualList"
			    :key="item.dcId"
			>
			    <!-- 左侧Logo + 产品名 -->
			    <div class="product-left">
			        <img class="product-logo" :src="item.dcLogoUrl" />
			        <span class="product-name">{{ item.dcName}}</span>
			    </div>
			
			    <!-- 中间：域名 + 提示 -->
			    <div class="product-right">
					<div class="product-info">
						<div class="product-domain">{{ item.h5Url }}</div>
						<div class="action-btn">Copy</div>
					</div>
			        <div class="product-desc">Please click the link and open it in your browser.</div>
			    </div>
			   
			    <!-- 未上线遮罩 -->
			    <div class="disabled-mask">
			        <span class="disabled-text">Malapit nang ilunsad</span>
			    </div>
			</div>
        </div>
		
		<!-- 跳转失败/被浏览器拦截时的提示弹窗 -->
		<div v-if="showFailDialog" class="fail-mask" @click.self="closeDialog">
			<div class="fail-dialog">
				<h3 class="fail-title">Unable to open link</h3>
				<p class="fail-desc">The link was blocked or could not be opened. You can copy the link below and open it in another browser.</p>
				<div class="fail-url">{{ failedUrl }}</div>
				<div class="fail-actions">
					<button class="fail-btn fail-btn-copy" @click="copyLink">Copy Link</button>
					<button class="fail-btn fail-btn-close" @click="closeDialog">Close</button>
				</div>
			</div>
		</div>
    </section>
</template>

<script>
export default{
    data(){
        return {
            productList: [],
			deviceId:"",
			baseUrl:"",
			virtualList:[
				{
					dcLogoUrl: require("./img/juanHand.png"),
					dcName: "JuanHand",
					h5Url: "juanhand.com",
					dcId:"JuanHand"
				},
				{
					dcLogoUrl: require("./img/tala.png"),
					dcName: "TALA",
					h5Url: "tala.ph",
					dcId:"TALA"
				}
			],
			showFailDialog: false,
			failedUrl: '',
			checkTimer: null
        }
    },
    metaInfo: {
        title: 'Loan Market'
    },

    created() {
        // 判断是否为安卓APP端：调用app方法获取deviceId,如果可以获取到，则是app
		try{
			this.deviceId = funpera.getDeviceIdFromApp();
		}catch(e){
			this.deviceId = "";
		}
		this.isIOSDevice = this.UTILS.isIOSDevice()
		this.baseUrl = location.origin;
        this.getDcProductList();
    },

    methods:{
        getDcProductList() {
            this.UTILS.axiosRequest('post', this.PATHS.loanPath + '/dc/getDcProductList ', {}, (res) => {
                this.UTILS.loadGif.hide();
                if (res.code == '0000') {
                    const list = res?.data || [];
                    this.productList = list.map(item => ({
                        ...item,
                        online: item.dcStatus == 1 ? true : false
                    }));
                } else {
                    this.productList = [];
                    this.UTILS.logStr(res.message);
                }
            }, 1);
        },

        handleAction(item) {
            if (!item.online) return;
            this.linkProduct(item);
        },
		
		linkProduct(item) {
		    this.UTILS.axiosRequest('post', this.PATHS.loanPath + '/dc/djDc ', {dcId: item.dcId}, (res) => {
		        this.UTILS.loadGif.hide();
		        if (res.code == '0000') {
					if(item.dcType == 2){
						this.handleAPP(item)
					}
					else if(item.dcType == 3 && !this.isIOSDevice){
						this.handleDownload(item)
					}
					else{
						this.handleCopy(item)
					}
		        }
		    }, 1);
		},
		
		//跳应用市场
		handleAPP(item){
			const appStoreUrl = item.appstoreUrl || "";
			const googlePlayUrl = item.googlePlayUrl || "";
			if(this.isIOSDevice){
				if(appStoreUrl){
					this.launchApp(appStoreUrl)
				}
				else{
					window.location.href = item.h5Url
				}
			}
			else{
				if(googlePlayUrl){
					this.launchApp(googlePlayUrl)
				}
				else{
					try{
						funpera.jumpBrowser(item.h5Url)
					}
					catch(e){
						window.location.href = item.h5Url
					}
				}
			}
		},
		
		//点击下载/跳转应用市场：用 <a> 标签触发跳转，跳不过去才弹窗
		launchApp(url) {
			var self = this
			this.clearCheck()
			this._hiddenOnce = false
			this._pendingUrl = url
			//注册 visibilitychange：页面隐藏 = 跳转成功；回到前台 = 清理并关闭误弹的弹窗
			this._onVisibility = function() {
				if (document.hidden || document.visibilityState === 'hidden') {
					//页面进入后台 = 跳转成功
					self._hiddenOnce = true
					self.clearCheckTimer()
					//如果超时已误弹了弹窗，关掉它
					if (self.showFailDialog) {
						self.closeDialog()
					}
				} else if (document.visibilityState === 'visible') {
					//回到前台：如果跳转过，关闭可能误弹的弹窗；无论如何清理检测
					if (self._hiddenOnce && self.showFailDialog) {
						self.closeDialog()
					}
					self.clearCheck()
				}
			}
			document.addEventListener('visibilitychange', this._onVisibility)
			document.addEventListener('pagehide', this._onVisibility)
			//用 <a target="_blank"> 触发跳转（比 window.open 兼容性好，Safari 不会返回 null）
			if(self.isIOSDevice){
				window.location.href = url
			}
			else{
				try{
					funpera.jumpBrowser(url)
				}
				catch(e){
					var a = document.createElement('a')
					a.href = url
					a.target = '_blank'
					a.rel = 'noopener'
					document.body.appendChild(a)
					a.click()
					document.body.removeChild(a)
				}
			}
			//兜底：2 秒后如果页面从未 hidden，说明可能被拦截，弹窗
			this.checkTimer = setTimeout(function() {
				if (!self._hiddenOnce) {
					self.clearCheck()
					self.showFail(url)
				}
			}, 2000)
		},
		
		//仅清理定时器（visibility hidden 时调用，保留监听以便返回时清理）
		clearCheckTimer() {
			if (this.checkTimer) {
				clearTimeout(this.checkTimer)
				this.checkTimer = null
			}
		},
		//清理全部检测监听和定时器
		clearCheck() {
			this.clearCheckTimer()
			this._hiddenOnce = false
			this._pendingUrl = ''
			if (this._onVisibility) {
				document.removeEventListener('visibilitychange', this._onVisibility)
				document.removeEventListener('pagehide', this._onVisibility)
				this._onVisibility = null
			}
		},
		//显示失败弹窗
		showFail(url) {
			this.failedUrl = url
			this.showFailDialog = true
		},
		closeDialog() {
			this.showFailDialog = false
			this.failedUrl = ''
		},
		
		//复制链接
		copyLink() {
			this.UTILS.copyText(this.failedUrl);
			this.showFailDialog = false
		},
		
		//下载安卓apk
		handleDownload(item) {
		    const downloadUrl = item.dcApkUrl || '';
		    if (downloadUrl) {
				try{
					funpera.jumpBrowser(downloadUrl)
				}
				catch(e){
					window.location.href = downloadUrl;
				}
		    } else {
				try{
					funpera.jumpBrowser(item.h5Url)
				}
				catch(e){
					window.location.href = item.h5Url
				}
		    }
		},
		
		// 复制H5链接
		handleCopy(item) {
			if(item.h5Url){
				this.UTILS.copyText(item.h5Url);
			}
			else{
				this.UTILS.logStr("The link does not exist.");
			}
		},
    },
	beforeDestroy() {
		this.clearCheck()
	}
}
</script>

<style scoped>
.page {
    min-height: 100%;
    background-color: #FFFFFF;
    padding-bottom: 0.5rem;
}

/* 顶部标题栏 */
.header {
    width: 100%;
    background-color: #ED7D31;
    padding: 0.10rem 0;
    box-sizing: border-box;
    text-align: center;
	font-size: 0.32rem;
    color: #FFFFFF;
}

/* 提示文字 */
.tips {
    padding: 0.3rem 0.4rem 0.2rem;
}
.tips-text {
    font-size: 0.24rem;
    color: #FC0000;
    text-align: left;
}

/* 产品列表 */
.product-list {
	display: flex;
	flex-direction: column;
	gap: 0.3rem 0;
    padding: 0.24rem 0.2rem 0;
}

/* 产品卡片 */
.product-card {
    position: relative;
    display: flex;
    align-items: center;
	gap: 0 0.1rem;
    background-color: #FFF5F5;
    border-radius: 0.24rem;
    padding: 0.24rem;
    box-sizing: border-box;
}
.product-card-disabled {
    background-color: #E0E0E0;
}

/* 左侧 */
.product-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: 1.2rem;
	word-break: break-all;
}
.product-logo {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.2rem;
    display: block;
    object-fit: cover;
}
.product-name {
    margin-top: 0.16rem;
    font-size: 0.2rem;
    color: #333333;
    line-height: 1.2;
    text-align: center;
    word-break: break-all;
}
.product-card-disabled .product-name {
    color: #666666;
}

/* 中间 */
.product-right {
    flex: 1;
    min-width: 0;
}
.product-info{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.info-app{
	justify-content: flex-end;
}
.product-domain {
    font-size: 0.24rem;
    color: #3D3D3D;
}
.product-card-disabled .product-domain {
    color: #999999;
    opacity: 0.5;
}
.product-desc {
    font-size: 0.16rem;
    color: #3D3D3D;
    line-height: 1.3;
	margin-top:0.06rem
}
.desc-app{
	text-align: right;
    margin-top: 0.2rem;
}
.product-card-disabled .product-desc {
    color: #999999;
    opacity: 0.5;
}

.action-btn {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.1rem;
    height: 0.5rem;
	line-height: 0.5rem;
    padding: 0 0.24rem;
    background-color: #5A6DFF;
    color: #FFFFFF;
    font-size: 0.24rem;
    border-radius: 0.3rem;
}

.action-btn-disabled {
    background-color: #A0A8CC;
    cursor: not-allowed;
}
.action-btn:active:not(.action-btn-disabled) {
    opacity: 0.85;
}

/* Google Play 图标 */
.play-icon {
    width: 0.36rem;
    height: 0.36rem;
}

/* 未上线遮罩 */
.disabled-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(160, 160, 160, 0.5);
    pointer-events: none;
	border-radius: 0.24rem;
}
.disabled-text {
    font-size: 0.30rem;
	font-weight: bold;
    color: #FFFFFF;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.fail-mask{
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9;
	padding: 0 0.6rem;
	box-sizing: border-box;
}
.fail-dialog{
	width: 100%;
	max-width: 6rem;
	background-color: #FFFFFF;
	border-radius: 0.2rem;
	padding: 0.4rem 0.32rem 0.32rem 0.32rem;
	box-sizing: border-box;
}
.fail-title{
	font-size: 0.32rem;
	font-weight: bold;
	color: #111827;
	text-align: center;
	margin: 0 0 0.2rem 0;
}
.fail-desc{
	font-size: 0.26rem;
	line-height: 0.4rem;
	color: #6B7280;
	text-align: center;
	margin: 0 0 0.24rem 0;
}
.fail-url{
	font-size: 0.24rem;
	line-height: 0.36rem;
	color: #2563EB;
	background-color: #F3F4F6;
	border-radius: 0.12rem;
	padding: 0.16rem 0.2rem;
	word-break: break-all;
	margin: 0 0 0.32rem 0;
}
.fail-actions{
	display: flex;
	gap: 0.2rem;
}
.fail-btn{
	flex: 1;
	height: 0.8rem;
	line-height: 0.8rem;
	text-align: center;
	font-size: 0.28rem;
	border: none;
	border-radius: 0.12rem;
	font-weight: 500;
	cursor: pointer;
	padding: 0;
}
.fail-btn-copy{
	color: #FFFFFF;
	background-color: #2563EB;
}
.fail-btn-copy:active{
	background-color: #1D4ED8;
}
.fail-btn-close{
	color: #6B7280;
	background-color: #F3F4F6;
}
.fail-btn-close:active{
	background-color: #E5E7EB;
}
</style>
